export default __webpack_public_path__ + "e83d23b52d73e94cdcc778356fdcd27e.svg";